export const QUIZ_KEYS = {
  LIST: 'quizzes',
} as const
